export interface Sensor {
    level: SensorLevel;
    data: { [key: string]: string };
    type: SensorType;
}

export interface PostSensor extends Sensor {
    locker_id?: string;
    ids?: { [key: string]: string };
}

export enum SensorLevel {
    DEBUG = 'debug',
    INFO = 'info',
    ERROR = 'error',
    WARNING = 'warning',
    CRITICAL = 'critical'
}


export enum SensorType {
    BADGE_NUMBER = 'badge_number',
    DOOR_STATUS = 'door_status',
    GENERAL_ERROR = 'general_error',
    JOB_INFO = 'job_info',
    PIN_CODE = 'pin_code',
    QR_CODE = 'qr_code',
    TAG_CODE = 'tag_code',
    TEXT = 'text'
}